import { Params, ParamMap } from '@angular/router';

const RAILROAD_KEY = 'rr';

export const toRailroadParams = (args: { railroadId?: number }): Params =>
	args.railroadId
		? {
				[RAILROAD_KEY]: args.railroadId ? args.railroadId : undefined,
		  }
		: undefined;

export const toRailroadListArgs = (
	paramMap: ParamMap
): { railroadId?: number } =>
	paramMap.has(RAILROAD_KEY)
		? {
				railroadId: +paramMap.get(RAILROAD_KEY),
		  }
		: undefined;
